import { useState } from "react";
import { Package } from "lucide-react";

// Real product photo when supplied, otherwise a neutral fallback panel.
// Replaces the previous shared stock still-life so the page stays honest
// about which products have real imagery and which don't yet. Also falls
// back to the placeholder if the real image URL 404s at load time.
export default function ProductImage({ src, alt, className = "", iconSize = "w-8 h-8" }) {
  const [errored, setErrored] = useState(false);
  if (src && !errored) {
    return (
      <img
        src={src}
        alt={alt || ""}
        loading="lazy"
        decoding="async"
        onError={() => setErrored(true)}
        className={`w-full h-full object-cover ${className}`}
      />
    );
  }
  return (
    <div className={`w-full h-full flex items-center justify-center bg-gradient-to-br from-white/[0.04] to-white/[0.01] ${className}`}>
      <Package className={`${iconSize} text-white/15`} strokeWidth={1.25} />
    </div>
  );
}
